<template>
  <div class="el-parameter-editor-item">
    <h1>{{ title }} ({{ replacerName }})</h1>
    <el-form inline label-position="top" class="el-parameter-editor-item-form" :model="current_value" ref="current_values">
      <el-row :gutter="20" class="el-parameter-editor-item-form-row">
        <el-col>
          <el-form-item prop="currentValue" label="Выберите значение" size="small">
            <el-radio-group
              v-model="current_value.value"
              style="margin-top: -3px; margin-left: 65px;"
              @change="onChange"
            >
              <el-radio-button :label="current_value.disabledValue"></el-radio-button>
              <el-radio-button :label="current_value.activeValue"></el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item prop="isClientEditable">
            <el-checkbox
              size="small"
              true-label=1
              false-label=0
              :checked="current_value.isClientEditable==1"
              v-model="current_value.isClientEditable"
              @change="onChange"
            >Доступно клиенту для редактирования</el-checkbox>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>

import {required} from "@/core/helpers/validators"

export default {
  name: "SwitchEditor",
  props: {
    title: {
      type: String,
      default: "Заголовок",
    },
    replacerName: {
      type: String,
      default: "#replacer",
    },
    currentValue: {
      type: Object,
      default: function() {},
    }
  },
  data() {
    return {
      current_value: this.currentValue,
      rules: {
        current_values: [required()],
      }
    }
  },
  mounted() {
    this.$refs['current_values'].validate();
  },
  beforeDestroy() {
    this.onDelete();
  },
  methods: {
    onChange() {
      this.$emit("updateValues", {
        replacer: this.replacerName,
        current_value: this.current_value,
        is_client_editable: this.current_value.isClientEditable
      });
    },
    onDelete() {
      this.$emit("removeEditor", {
        replacer: this.replacerName,
      });
    },
  },
};
</script>

<style>
div .el-parameter-editor-item {
  border: thin solid #3883fa;
  margin-top: 5px;
  padding: 0 10px;
}

.el-parameter-editor-item-form {
  max-width: 100%;
}

.el-parameter-editor-item-form-row {
  display: flex;
  justify-content: space-around;
}
</style>
